var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v(_vm._s(_vm.$tc('views.contact.settings.document-layout.create-document-layout', 1)))]),_c('document-layout-form',{ref:"documentLayoutForm",attrs:{"owner-id":_vm.ownerId},on:{"post-handle-form-data":_vm.onSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }